import React, { useEffect, useState } from "react";

import { GetLanguageListResponse } from "../../../common/api/admin-api/GetLanguageListResponse";
import { LanguageItem, mapToLanguageItem } from "../listing/LanguagesListing";
import { useAdminLanguageApi } from "../useAdminLanguageApi";
import { LanguageListingContext } from "./LanguageListingContext";

interface LanguageListingProviderProps {
    children: React.ReactNode;
}

export const LanguageListingProvider: React.FC<LanguageListingProviderProps> = ({
    children
}: LanguageListingProviderProps) => {
    const { getLanguageList } = useAdminLanguageApi();

    const [languageItems, setLanguageItems] = useState<LanguageItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        getLanguageList()
            .then((response: GetLanguageListResponse) => {
                const languages = response.items.map(mapToLanguageItem);

                setLanguageItems(languages);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const addLanguageItem = (item: LanguageItem) => {
        setLanguageItems((prevState) => [...prevState, item]);
    };

    return (
        <LanguageListingContext.Provider value={{ languageItems, isLoading, addLanguageItem }}>
            {children}
        </LanguageListingContext.Provider>
    );
};
